export const userChat = {
  namespaced: true,
  state: {
    showChat: false,
    isNewRoom: false,
    newUser: { }
  },
  getters: { 
    getShowChat: (state: any) => {
      return state.showChat;
    },
    getIsNewRoom: (state: any) => {
      return state.isNewRoom;
    },
    getNewUser: (state: any) => {
      return state.newUser;
    }
  },
  actions: {
    clear({ commit }: any){
      commit("clear");
    },
  },
  mutations: {
    clear(state: any) {
      state.showChat = false;      
      state.isNewRoom = false;
      state.newUser = { };
    },    
    setShowChat(state: any, value: boolean) { 
      state.showChat = value;
    },
    setIsNewRoom(state: any, value: boolean) {
      state.isNewRoom = value;
    },
    addNewRoom(state: any, user: object) {
      state.isNewRoom = true;
      state.newUser = {
        ...user
      }
    }
  }
};